import React, {FC} from 'react';

import {getParameters} from '../../../editors/expressions/expressionInferHelpers';
import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import type {AtomCardProps} from './atomCard';
import {AtomIcon} from './atomIcon';
import {AtomTitle} from './atomTitle';
import {AtomParameterPicker} from './pickers/atomParameterPicker';

/*
 * Component.
 */

export const AddPeriodAtomCard: FC<AtomCardProps> = (props) => {
  const {atom, isDisabled, onUpdateAtom, onCancel} = props;
  const [periodParam, amountParam] = getParameters(atom);

  const title = (
    <AtomTitle atom={atom}>
      <AtomParameterPicker
        parameter={amountParam}
        atom={atom}
        isDisabled={isDisabled}
        onUpdate={onUpdateAtom}
      />

      <AtomParameterPicker
        parameter={periodParam}
        atom={atom}
        isDisabled={isDisabled}
        onUpdate={onUpdateAtom}
      />
    </AtomTitle>
  );

  return (
    <RuleMultilineParameterCard
      errorMessage={atom.errorMessage}
      icon={<AtomIcon atom={atom} />}
      title={title}
      onCancel={onCancel}
    />
  );
};
